import React, { useEffect, useRef, useState } from "react"
import { toast } from "react-toastify"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import {
  // calculateTotalTaxes,
  // convertOrderCombosToCartCombos,
  // convertOrderItemsToCartItems,
  // createOfflineOrder,
  getOrdersTaxItems,
  isPosTerminalPayment,
  ObjectValues,
  RNWebViewApi
} from "utils"
import { Button } from "components"
import { approvePayment } from "services"
import { addNewShiftOrder } from "@redux"
import classes from "./ApprovePaymentModalButton.module.scss"
import clsx from "clsx"

const ApprovePaymentModalButton = props => {
  const {
    setOrders,
    cashTypes,
    selectedOrders,
    setSelectedOrders,
    totalSelectedOrders,
    setOpenPaymentApproveModal,
    numberOfSelectedOrders
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  // const branchId =
  //   useSelector(state => state.userAccountInfo.branchId)

  // const isOnline =
  //   useSelector(state => !state.internetStatus.forceOffline)

  const [sending, setSending] = useState(false)

  const unmount = useRef(false)

  const getChange = () => {
    const totalCashTypes =
      cashTypes.reduce((t, cashType) =>
        t += Number(cashType.amount)
        , 0
      )

    return totalSelectedOrders - totalCashTypes
  }

  const handleCancel = () => {
    setOpenPaymentApproveModal(false)
  }

  const newShiftOrder = (order, cashType) => {
    const taxesAndCharges =
      getOrdersTaxItems(order)

    const taxes =
      taxesAndCharges.reduce((t, tax) =>
        t += !tax.isNotTax ? tax.amount : 0,
        0
      )

    const charges =
      taxesAndCharges.reduce((t, charge) =>
        t += charge.isNotTax ? charge.amount : 0
        , 0
      )

    const discounts =
      order.foodDiscount +
      order.deliveryDiscount

    const shiftOrder = {
      taxes,
      charges,
      discounts,
      cashTypes: cashType
    }

    dispatch(
      addNewShiftOrder(shiftOrder)
    )
  }

  const validate = () => {
    if (cashTypes.length === 0) {
      toast.error("لطفا نوع پرداخت را انتخاب کنید")

      return false
    }

    return true
  }

  const handleApprovePayments = async () => {
    if (!validate()) return

    setSending(true)

    const orders =
      ObjectValues(selectedOrders)

    const posPayment =
      isPosTerminalPayment(cashTypes)

    try {
      if (posPayment) {
        const response =
          await RNWebViewApi.postMessage(
            {
              type: "sadadPaymentRequest",
              paymentDetails: {
                amount: Number(cashTypes[0].amount),
                orderCode:
                  orders.length > 1 ? orders.length : orders[0].code
              }
            }
          )

        const success =
          response.code === 0 &&
          response.message === "تراکنش با موفقیت انجام شد"

        if (!success) throw Error("Payment failed")
      }

      for (const order of orders) {
        const cashType =
          cashTypes.map(c => ({
            type: c.value,
            amount:
              numberOfSelectedOrders === 1
                ?
                Number(c.amount) > totalSelectedOrders
                  ? totalSelectedOrders
                  : Number(c.amount)
                :
                order.totalBillAmount
          }))

        const query =
          !!order.isGuestOrder
            ? { orderId: order._id }
            : { accountId: order.accountId }

        await approvePayment(
          {
            orderIds: [order._id],
            cashType
          },
          query
        )

        newShiftOrder(order, cashType)

        setSelectedOrders(prev => {
          const previousSelectedOrders = { ...prev }

          delete previousSelectedOrders[order._id]

          return previousSelectedOrders
        })

        setOrders(prev =>
          prev.map(o =>
            o._id === order._id
              ? { ...o, orderStatus: "paid" }
              : o
          )
        )
      }

      if (unmount.current) return

      setOpenPaymentApproveModal(false)

      toast.success("سفارشات تایید شد")
    } catch (err) {
      console.log(err)

      toast.error("سفارشات تایید نشد")

      if (unmount.current) return

      setSending(false)
    }
  }

  // const handleOfflineApprovePayments = () => {
  //   const orders =
  //     ObjectValues(selectedOrders)

  //   orders.forEach(order => {
  //     const totalDiscount =
  //       order.deliveryDiscount +
  //       order.foodDiscount

  //     const totalTaxes =
  //       calculateTotalTaxes(order)

  //     const offlineOrderDetails = {
  //       branchId,
  //       total: order.totalBillAmount,
  //       onlineOrderId: order._id,
  //       code: order.code,
  //       totalTaxes,
  //       totalDiscount,
  //       totalCharges: 0,
  //       accountId: order.accountId,
  //       orderStatus: "paid",
  //       onlineInitialOrderStatus: "pending",
  //       deliveryType: order.deliveryType,
  //       deliveryAddress: order.address,
  //       deliveryService: order.deliveryService,
  //       order: {
  //         tableNumber: order.tableNumber,
  //         items: convertOrderItemsToCartItems(order.items),
  //         combos: convertOrderCombosToCartCombos(order.items)
  //       },
  //       deliveryFees: {
  //         fee: order.deliveryFee
  //       },
  //       cashTypes:
  //         cashTypes.map(c => ({
  //           type: c.value,
  //           amount: numberOfSelectedOrders === 1
  //             ?
  //             Number(c.amount) > totalSelectedOrders
  //               ? totalSelectedOrders
  //               : Number(c.amount)
  //             :
  //             order.totalBillAmount
  //         }))
  //     }

  //     createOfflineOrder(offlineOrderDetails)
  //   })

  //   setOpenPaymentApproveModal(false)

  //   setSelectedOrders({})
  // }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  const change = getChange()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <Button
        disabled={sending}
        color="danger"
        onClick={handleCancel}
        className={clsx(
          classes["button"],
          isLtr && classes["button-ltr"]
        )}
      >
        {t("انصراف")}
      </Button>

      <Button
        disabled={change > 0}
        loading={sending}
        color="success"
        onClick={handleApprovePayments}
      >
        {t("تایید")}
      </Button>
    </div>
  )
}

export default ApprovePaymentModalButton